/**
* This is a TypeGen auto-generated file.
* Any changes made to this file will be lost when the file is regenerated.
*/

import {Observable} from "rxjs";
import {Injectable, Injector} from "@angular/core";
import {HttpEvent} from "@angular/common/http";
import {ApiServiceBase} from "../../api-service-base";
import {AssessmentSettingsResponse} from "../model/assessment-settings-response";
import {AudioInputChannelsForTrainingRoomAndRecorderMicPanelResponse} from "../model/audio-input-channels-for-training-room-and-recorder-mic-panel-response";
import {CanRecordRequest} from "../model/can-record-request";
import {CanRecordResponse} from "../model/can-record-response";
import {ClientResponse} from "../model/client-response";
import {ConnectedWebClient} from "../model/connected-web-client";
import {DeleteRequest} from "../model/delete-request";
import {Exstreamer} from "../model/exstreamer";
import {FilteredClientResponse} from "../model/filtered-client-response";
import {GetClientPropertiesResponse} from "../model/get-client-properties-response";
import {GetDynamicAudioInputChannelDataForRecorderResponse} from "../model/get-dynamic-audio-input-channel-data-for-recorder-response";
import {IMappingIdentifier} from "../model/i-mapping-identifier";
import {InternalClassesResponse} from "../model/internal-classes-response";
import {LdapConfiguration} from "../model/ldap-configuration";
import {LdapRoleMapping} from "../model/ldap-role-mapping";
import {ListData} from "../model/list-data";
import {MasterOfCeremonyMapping} from "../model/master-of-ceremony-mapping";
import {OrderObjectRequest} from "../model/order-object-request";
import {Permissions} from "../model/permissions";
import {PlayerMapping} from "../model/player-mapping";
import {RecorderMapping} from "../model/recorder-mapping";
import {RegisterMoCRequest} from "../model/register-mo-c-request";
import {RegisterPlayerRequest} from "../model/register-player-request";
import {RegisterRecorderRequest} from "../model/register-recorder-request";
import {RegisterResponse} from "../model/register-response";
import {RegisterTabletRequest} from "../model/register-tablet-request";
import {RevertRecorderToDefaultDynamicInputsRequest} from "../model/revert-recorder-to-default-dynamic-inputs-request";
import {SetDefaultDynamicAudioInputPresetRequest} from "../model/set-default-dynamic-audio-input-preset-request";
import {Setting} from "../model/setting";
import {ShutdownMappedDeviceRequest} from "../model/shutdown-mapped-device-request";
import {SimRole} from "../model/sim-role";
import {StartMappedDeviceRequest} from "../model/start-mapped-device-request";
import {SuccessResponse} from "../model/success-response";
import {SystemInformationResponse} from "../model/system-information-response";
import {SystemProxyRequest} from "../model/system-proxy-request";
import {TabletMapping} from "../model/tablet-mapping";
import {TakeAwayPlayersRequest} from "../model/take-away-players-request";
import {TraceRecord} from "../model/trace-record";
import {TrainingRoomPcMapping} from "../model/training-room-pc-mapping";
import {UpdateAllPlayerCredentialsRequest} from "../model/update-all-player-credentials-request";
import {UpdateAllRecorderMappingCredentialsRequest} from "../model/update-all-recorder-mapping-credentials-request";
import {UpdateDynamicAudioInputChannelsForRecorderRequest} from "../model/update-dynamic-audio-input-channels-for-recorder-request";
import {ViewingStationMapping} from "../model/viewing-station-mapping";
import {WebClientConnection} from "../model/web-client-connection";
import {WebClientType} from "../model/web-client-type";
import {WebSettings} from "../model/web-settings";

@Injectable({
    providedIn: "root",
})
export class SimSystemService extends ApiServiceBase {
	constructor(injector: Injector) {
        super(injector);
	}
    public canRecord(request: CanRecordRequest) {
        return super.post<CanRecordResponse>(`/api/System/CanRecord`, request);
    }

    public checkEnvironment() {
        return super.get<SuccessResponse>(`/api/System/CheckEnvironment`, );
    }

    public checkUserUsedRoleInUsersAndAcls(simRoleId: string) {
        return super.get<boolean>(`/api/System/CheckUserUsedRoleInUsersAndAcls`, {simRoleId: simRoleId});
    }

    public deleteExstreamer(exstreamer: Exstreamer) {
        return super.post<boolean>(`/api/System/DeleteExstreamer`, exstreamer);
    }

    public deleteLdapRoleMapping(ldapRoleMapping: LdapRoleMapping) {
        return super.post<boolean>(`/api/System/DeleteLdapRoleMapping`, ldapRoleMapping);
    }

    public deletePlayerMapping(request: DeleteRequest) {
        return super.post<boolean>(`/api/System/DeletePlayerMapping`, request);
    }

    public deleteRecorderMapping(request: DeleteRequest) {
        return super.post<boolean>(`/api/System/DeleteRecorderMapping`, request);
    }

    public deleteSimRole(simRoleId: string) {
        return super.get<boolean>(`/api/System/DeleteSimRole`, {simRoleId: simRoleId});
    }

    public deleteTabletMapping(request: DeleteRequest) {
        return super.post<boolean>(`/api/System/DeleteTabletMapping`, request);
    }

    public deleteTrainingRoomPcMapping(request: DeleteRequest) {
        return super.post<boolean>(`/api/System/DeleteTrainingRoomPcMapping`, request);
    }

    public deleteViewingStationMapping(request: DeleteRequest) {
        return super.post<boolean>(`/api/System/DeleteViewingStationMapping`, request);
    }

    public getAssessmentSettings() {
        return super.get<AssessmentSettingsResponse>(`/api/System/GetAssessmentSettings`, );
    }

    public getAudioInputChannelsForTrainingRoomAndRecorderMicPanel(trainingRoomId: string, webRecorderId: string) {
        return super.get<AudioInputChannelsForTrainingRoomAndRecorderMicPanelResponse>(`/api/System/GetAudioInputChannelsForTrainingRoomAndRecorderMicPanel`, {trainingRoomId: trainingRoomId, webRecorderId: webRecorderId});
    }

    public getAuditTrail(from: Date | string, to: Date | string, searchTerm: string, searchColumn: string, sortColumn: string, sortAscending: boolean, page: number, pageSize: number) {
        return super.get<ListData<TraceRecord>>(`/api/System/GetAuditTrail`, {from: from, to: to, searchTerm: searchTerm, searchColumn: searchColumn, sortColumn: sortColumn, sortAscending: sortAscending, page: page, pageSize: pageSize});
    }

    public getClientName() {
        return super.get<string>(`/api/System/GetClientName`, );
    }

    public getClientProperties() {
        return super.get<GetClientPropertiesResponse>(`/api/System/GetClientProperties`, );
    }

    public getConnectedWebClients() {
        return super.get<ConnectedWebClient[]>(`/api/System/GetConnectedWebClients`, );
    }

    public getConnectedWebClientsForExecutor(executorId: string) {
        return super.get<ConnectedWebClient[]>(`/api/System/GetConnectedWebClientsForExecutor`, {executorId: executorId});
    }

    public getDebriefingPlayerById(playerId: string) {
        return super.get<PlayerMapping>(`/api/System/GetDebriefingPlayerById`, {playerId: playerId});
    }

    public getDebriefingPlayers() {
        return super.get<PlayerMapping[]>(`/api/System/GetDebriefingPlayers`, );
    }

    public getDebriefingPlayersByIds(playerIds: string[]) {
        return super.post<PlayerMapping[]>(`/api/System/GetDebriefingPlayersByIds`, playerIds);
    }

    public getDynamicAudioInputChannelDataForRecorder(recorderId: string) {
        return super.get<GetDynamicAudioInputChannelDataForRecorderResponse>(`/api/System/GetDynamicAudioInputChannelDataForRecorder`, {recorderId: recorderId});
    }

    public getExstreamers() {
        return super.get<Exstreamer[]>(`/api/System/GetExstreamers`, );
    }

    public getFilteredKnownAndConnectedClients(searchTerm: string, searchColumn: string, sortColumn: string, sortAscending: boolean, page: number, pageSize: number) {
        return super.get<FilteredClientResponse>(`/api/System/GetFilteredKnownAndConnectedClients`, {searchTerm: searchTerm, searchColumn: searchColumn, sortColumn: sortColumn, sortAscending: sortAscending, page: page, pageSize: pageSize});
    }

    public getFilteredLdapRoleMappings(searchTerm: string, searchColumn: string, sortColumn: string, sortAscending: boolean, page: number, pageSize: number) {
        return super.get<ListData<LdapRoleMapping>>(`/api/System/GetFilteredLdapRoleMappings`, {searchTerm: searchTerm, searchColumn: searchColumn, sortColumn: sortColumn, sortAscending: sortAscending, page: page, pageSize: pageSize});
    }

    public getFilteredMasterOfCeremonyMappings(searchTerm: string, searchColumn: string, sortColumn: string, sortAscending: boolean, page: number, pageSize: number) {
        return super.get<ListData<MasterOfCeremonyMapping>>(`/api/System/GetFilteredMasterOfCeremonyMappings`, {searchTerm: searchTerm, searchColumn: searchColumn, sortColumn: sortColumn, sortAscending: sortAscending, page: page, pageSize: pageSize});
    }

    public getFilteredPlayerMappings(searchTerm: string, searchColumn: string, sortColumn: string, sortAscending: boolean, page: number, pageSize: number) {
        return super.get<ListData<PlayerMapping>>(`/api/System/GetFilteredPlayerMappings`, {searchTerm: searchTerm, searchColumn: searchColumn, sortColumn: sortColumn, sortAscending: sortAscending, page: page, pageSize: pageSize});
    }

    public getFilteredRecorderMappings(searchTerm: string, searchColumn: string, sortColumn: string, sortAscending: boolean, page: number, pageSize: number) {
        return super.get<ListData<RecorderMapping>>(`/api/System/GetFilteredRecorderMappings`, {searchTerm: searchTerm, searchColumn: searchColumn, sortColumn: sortColumn, sortAscending: sortAscending, page: page, pageSize: pageSize});
    }

    public getFilteredTabletMappings(searchTerm: string, searchColumn: string, sortColumn: string, sortAscending: boolean, page: number, pageSize: number) {
        return super.get<ListData<TabletMapping>>(`/api/System/GetFilteredTabletMappings`, {searchTerm: searchTerm, searchColumn: searchColumn, sortColumn: sortColumn, sortAscending: sortAscending, page: page, pageSize: pageSize});
    }

    public getFilteredTrainingRoomPcMappings(searchTerm: string, searchColumn: string, sortColumn: string, sortAscending: boolean, page: number, pageSize: number) {
        return super.get<ListData<TrainingRoomPcMapping>>(`/api/System/GetFilteredTrainingRoomPcMappings`, {searchTerm: searchTerm, searchColumn: searchColumn, sortColumn: sortColumn, sortAscending: sortAscending, page: page, pageSize: pageSize});
    }

    public getFilteredViewingStationMappings(searchTerm: string, searchColumn: string, sortColumn: string, sortAscending: boolean, page: number, pageSize: number) {
        return super.get<ListData<ViewingStationMapping>>(`/api/System/GetFilteredViewingStationMappings`, {searchTerm: searchTerm, searchColumn: searchColumn, sortColumn: sortColumn, sortAscending: sortAscending, page: page, pageSize: pageSize});
    }

    public getKnownAndConnectedClients() {
        return super.get<ClientResponse>(`/api/System/GetKnownAndConnectedClients`, );
    }

    public getKnownClientIpNameDict() {
        return super.get<{ [key: string]: string[]; }>(`/api/System/GetKnownClientIpNameDict`, );
    }

    public getLdapSettings() {
        return super.get<LdapConfiguration>(`/api/System/GetLdapSettings`, );
    }

    public getMacAddress(ipOrHostname: string) {
        return super.get<string>(`/api/System/GetMacAddress`, {ipOrHostname: ipOrHostname});
    }

    public getMappingIdentifier() {
        return super.get<IMappingIdentifier>(`/api/System/GetMappingIdentifier`, );
    }

    public getMediaScreens() {
        return super.get<PlayerMapping[]>(`/api/System/GetMediaScreens`, );
    }

    public getMoCMappingById(mocMappingId: string) {
        return super.get<MasterOfCeremonyMapping>(`/api/System/GetMoCMappingById`, {mocMappingId: mocMappingId});
    }

    public getPlayerMappings() {
        return super.get<PlayerMapping[]>(`/api/System/GetPlayerMappings`, );
    }

    public getPlayerMappingsByIds(playerMappingIds: string[]) {
        return super.post<PlayerMapping[]>(`/api/System/GetPlayerMappingsByIds`, playerMappingIds);
    }
/**
 * Returns all players regardless of type (mediascreen, debriefing-player)
 */ 

    public getPlayers() {
        return super.get<PlayerMapping[]>(`/api/System/GetPlayers`, );
    }

    public getRecorderMappingById(recorderMappingId: string) {
        return super.get<RecorderMapping>(`/api/System/GetRecorderMappingById`, {recorderMappingId: recorderMappingId});
    }

    public getRecorderMappings() {
        return super.get<RecorderMapping[]>(`/api/System/GetRecorderMappings`, );
    }

    public getRolePermissions(roleId: string) {
        return super.get<Permissions[]>(`/api/System/GetRolePermissions`, {roleId: roleId});
    }

    public getSettings() {
        return super.get<WebSettings>(`/api/System/GetSettings`, );
    }

    public getSettingsForConfig(searchColumn: string, searchTerm: string, descriptionLanguage: string) {
        return super.get<Setting[]>(`/api/System/GetSettingsForConfig`, {searchColumn: searchColumn, searchTerm: searchTerm, descriptionLanguage: descriptionLanguage});
    }

    public getSimRoles() {
        return super.get<SimRole[]>(`/api/System/GetSimRoles`, );
    }

    public getSimRolesForUpsertUser() {
        return super.get<SimRole[]>(`/api/System/GetSimRolesForUpsertUser`, );
    }

    public getSystemInformation() {
        return super.get<SystemInformationResponse>(`/api/System/GetSystemInformation`, );
    }

    public getSystemTime() {
        return super.get<number>(`/api/System/GetSystemTime`, );
    }

    public getTabletMappingById(tabletMappingId: string) {
        return super.get<TabletMapping>(`/api/System/GetTabletMappingById`, {tabletMappingId: tabletMappingId});
    }

    public getTrainingRoomPcMappings() {
        return super.get<TrainingRoomPcMapping[]>(`/api/System/GetTrainingRoomPcMappings`, );
    }

    public getViewingStationMappingById(viewingStationMappingId: string) {
        return super.get<ViewingStationMapping>(`/api/System/GetViewingStationMappingById`, {viewingStationMappingId: viewingStationMappingId});
    }

    public getViewingStationMappings() {
        return super.get<ViewingStationMapping[]>(`/api/System/GetViewingStationMappings`, );
    }

    public getWebClientConnections(webClientType: WebClientType, start: Date | string, end: Date | string) {
        return super.get<WebClientConnection[]>(`/api/System/GetWebClientConnections`, {webClientType: webClientType, start: start, end: end});
    }

    public internalClasses() {
        return super.get<InternalClassesResponse>(`/api/System/InternalClasses`, );
    }

    public ping(request: SystemProxyRequest) {
        return super.post<boolean>(`/api/System/Ping`, request);
    }

    public registerMoC(request: RegisterMoCRequest) {
        return super.post<RegisterResponse<MasterOfCeremonyMapping>>(`/api/System/RegisterMoC`, request);
    }

    public registerPlayer(request: RegisterPlayerRequest) {
        return super.post<RegisterResponse<PlayerMapping>>(`/api/System/RegisterPlayer`, request);
    }

    public registerRecorder(request: RegisterRecorderRequest) {
        return super.post<RegisterResponse<RecorderMapping>>(`/api/System/RegisterRecorder`, request);
    }

    public registerTablet(request: RegisterTabletRequest) {
        return super.post<RegisterResponse<TabletMapping>>(`/api/System/RegisterTablet`, request);
    }

    public registerViewingStation(request: RegisterTabletRequest) {
        return super.post<RegisterResponse<ViewingStationMapping>>(`/api/System/RegisterViewingStation`, request);
    }

    public reloadClient(clientId: string) {
        return super.get<boolean>(`/api/System/ReloadClient`, {clientId: clientId});
    }

    public revertRecorderToDefaultDynamicInputs(request: RevertRecorderToDefaultDynamicInputsRequest) {
        return super.post<boolean>(`/api/System/RevertRecorderToDefaultDynamicInputs`, request);
    }

    public saveLdapSettings(ldapConfiguration: LdapConfiguration) {
        return super.post<void>(`/api/System/SaveLdapSettings`, ldapConfiguration);
    }

    public setDefaultDynamicAudioInputPreset(request: SetDefaultDynamicAudioInputPresetRequest) {
        return super.post<boolean>(`/api/System/SetDefaultDynamicAudioInputPreset`, request);
    }

    public shutdownMappedDevice(request: ShutdownMappedDeviceRequest) {
        return super.post<SuccessResponse>(`/api/System/ShutdownMappedDevice`, request);
    }

    public switchEnvironment(domain: string) {
        return super.get<void>(`/api/System/SwitchEnvironment`, {domain: domain});
    }
/**
 * Take away Player
 */ 

    public takeAwayPlayers(request: TakeAwayPlayersRequest) {
        return super.post<void>(`/api/System/TakeAwayPlayers`, request);
    }

    public testLdapSettings(ldapConfiguration: LdapConfiguration) {
        return super.post<string>(`/api/System/TestLdapSettings`, ldapConfiguration);
    }

    public updateAllPlayerCredentials(request: UpdateAllPlayerCredentialsRequest) {
        return super.post<boolean>(`/api/System/UpdateAllPlayerCredentials`, request);
    }

    public updateAllRecorderMappingCredentials(request: UpdateAllRecorderMappingCredentialsRequest) {
        return super.post<boolean>(`/api/System/UpdateAllRecorderMappingCredentials`, request);
    }

    public updateDynamicAudioInputChannelsForRecorder(request: UpdateDynamicAudioInputChannelsForRecorderRequest) {
        return super.post<boolean>(`/api/System/UpdateDynamicAudioInputChannelsForRecorder`, request);
    }

    public updateExstreamer(exstreamer: Exstreamer) {
        return super.post<boolean>(`/api/System/UpdateExstreamer`, exstreamer);
    }

    public updateLdapRoleMapping(ldapRoleMapping: LdapRoleMapping) {
        return super.post<boolean>(`/api/System/UpdateLdapRoleMapping`, ldapRoleMapping);
    }

    public updateMasterOfCeremonyMapping(mapping: MasterOfCeremonyMapping) {
        return super.post<boolean>(`/api/System/UpdateMasterOfCeremonyMapping`, mapping);
    }

    public updateOrderByObjectModel(orderObject: OrderObjectRequest) {
        return super.post<boolean>(`/api/System/UpdateOrderByObjectModel`, orderObject);
    }

    public updatePlayerMapping(mapping: PlayerMapping) {
        return super.post<boolean>(`/api/System/UpdatePlayerMapping`, mapping);
    }

    public updatePlayerMappings(playerMappings: PlayerMapping[]) {
        return super.post<boolean>(`/api/System/UpdatePlayerMappings`, playerMappings);
    }

    public updateProxySettings() {
        return super.post<boolean>(`/api/System/UpdateProxySettings`, {});
    }

    public updateRecorderMapping(mapping: RecorderMapping) {
        return super.post<boolean>(`/api/System/UpdateRecorderMapping`, mapping);
    }

    public updateSetting(setting: Setting) {
        return super.post<boolean>(`/api/System/UpdateSetting`, setting);
    }

    public updateTabletMapping(mapping: TabletMapping) {
        return super.post<boolean>(`/api/System/UpdateTabletMapping`, mapping);
    }

    public updateTrainingRoomPcMapping(mapping: TrainingRoomPcMapping) {
        return super.post<boolean>(`/api/System/UpdateTrainingRoomPcMapping`, mapping);
    }

    public updateViewingStationMapping(mapping: ViewingStationMapping) {
        return super.post<boolean>(`/api/System/UpdateViewingStationMapping`, mapping);
    }

    public upsertSimRole(simRole: SimRole) {
        return super.post<boolean>(`/api/System/UpsertSimRole`, simRole);
    }

    public wakeMappedDevice(request: StartMappedDeviceRequest) {
        return super.post<SuccessResponse>(`/api/System/WakeMappedDevice`, request);
    }
}